<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectForm" slot-scope="scope">
        <el-select
          v-model="form.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectAddChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="moduleTypeNameSearch" slot-scope="scope">
        <el-select
          v-model="query.moduleTypeName"
          placeholder="请选择工单类型"
          style="width: 100%"
          @change="(value)=>moduleTypeNamChange(value,1)"
        >
          <el-option
            v-for="item in moduleTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="moduleTypeNameForm" slot-scope="scope">
        <el-select
          v-model="form.moduleTypeName"
          placeholder="请选择工单类型"
          style="width: 100%"
          :disabled="disabled"
          @change="(value)=>moduleTypeNamChange(value,2)"
        >
          <el-option
            v-for="item in moduleTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="subModuleIdForm" slot-scope="scope">
        <el-select
          v-model="form.subModuleId"
          placeholder="请选择工单子类型"
          style="width: 100%"
          :disabled="disabled"
        >
          <el-option
            v-for="item in subModuleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="subModuleIdSearch" slot-scope="scope">
        <el-select
          v-model="query.subModuleId"
          placeholder="请选择工单子类型"
          style="width: 100%"
          @change="subModuleIdChange(value)"
        >
          <el-option
            v-for="item in subModuleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot='attachIdsForm' >
          <vupload :fileList.sync="form.attachIds" message="请上传jpg,png或者MP4格式文件！"  :types="['audio/mp4','video/mp4','image/png','image/jpeg','image/x-png','image/pjpeg']"  :limit="3" :max="20*1024*1024" :disabled="disabled"></vupload>
      </template>
      <template slot='imgAttachIdForm' >
          <vupload :fileList.sync="form.imgAttachId" message="请上传jpg或者png格式文件！" :types="vuploadTypes" :limit="1" :max="0.2*1024*1024" :disabled="disabled"></vupload>
      </template>
      <template slot="contentForm">
        <VueEditor id="editor" :disabled="disabled" v-model="form.content" useCustomImageHandler  @image-added="handleImageAdded"></VueEditor>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import { putFile } from "@/api/crmedical/contract/add";
  import {add, getDetail, getList, remove, update} from "@/api/v4ward/paid/order-service/paidorderservice.js";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {
    modulesSetting
  } from "@/api/crmedical/order/order-add";
  import {getAttachByMainIdList} from "@/api/crmedical/attach/attach";
  import {
    getAllSubModuleList
  } from "@/api/crmedical/order/order";
  var inputNumber = (rule, value, callback) => {
    var regNumber = /^\+?[1-9][0-9]*$/;
    if (!regNumber.test(value)) {
      callback(new Error('请输入大于 0 的整数！'));
    } else {
      callback();
    }
  };
import vupload from "@/views/components/v-upload-types.vue";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
  export default {
    components:{
      vupload,VueEditor
    },
    data() {
      return {
        vuploadTypes:['image/png','image/jpeg','image/x-png','image/pjpeg'],
        disabled:false,//上传组件是否可编辑
        moduleTypeList: [],//工单类型下拉框数据
        subModuleList: [],//工单子类型下拉框数据
        listFlag: false,
        projectList: [],//项目下拉框数据
        form: {
          attachIds:[],//宣传图
          imgAttachId:[],//图标
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          selection: false,
          indexLabel:'序号',
          columnBtn: false,
          searchMenuSpan: 6,
          labelWidth: 120,
          searchLabelWidth:110,
          menuPosition:'center',
          searchMenuPosition:'left',
          viewBtn:true,
          emptyBtnText:'重置',
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              span:8,
              editDisabled: true,
              addDisplay: false,
            },
            {
              label: "项目名称",
              prop: "project",
              search: true,
              searchslot:true,
              formslot: true,
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              hide: true,
              addDisplay: true,
              viewDisplay:false,
              editDisplay: false,
              span: 8,
            },
            {
              label: "工单类型",
              prop: "moduleType",
              type: "select",
              dicUrl: "/api/blade-system/dict/dictionary?code=module_type",
              dataType: "number",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              span:8,
              display: false,
            },
            {
              label: "工单类型",
              prop: "moduleTypeName",
              searchslot:true,
              formslot: true,
              rules: [{
                required: true,
                message: "请选择工单类型",
                trigger: "change"
              }],
              hide: true,
              span:8,
              search: true,
            },
            {
              label: "工单子类型",
              prop: "subModuleId",
              searchslot:true,
              formslot: true,
              search: true,
              hide: true,
              rules: [{
                required: true,
                message: "请选择工单子类型",
                trigger: "change"
              }],
              span:8,
              
            },
            {
              label: "工单子类型",
              prop: "subModuleName",
              span:8,
              addDisplay: false,
              viewDisplay:false,
              editDisplay: false,
            },
            {
                label: "上门费",
                type:'number',
                prop: "dropInFee",
                span:8,
                rules: [{
                      required: true,
                      message: "请输入上门费",
                      trigger: "blur"
                    },
                    {pattern: /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-999999999.99',trigger: "change"},
                ]
            },

            {
              label: "排序",
              prop: "sort",
              span:8,
              rules: [
                {
                  required: true,
                  message: "请输入排序",
                  trigger: "change"
                },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },
              ],
              maxlength: 3,
              showWordLimit: true,
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              rules: [{
                    required: true,
                    message: "请输入备注",
                    trigger: "change"
                }],
              span: 24,
              type: 'textarea',
            },
            {
              label:'图标',
              prop:'imgAttachId',
              formslot:true,
              hide:true,
              rules: [{
                    required: true,
                    message: "请上传图标",
                    trigger: "change"
                }],
              span: 24,
            },
            {
              label:'宣传图',
              prop:'attachIds',
              formslot:true,
              hide:true,
              rules: [{
                    required: true,
                    message: "请上传宣传图",
                    trigger: "change"
                }],
              span: 24,
            },
            {
              label: "服务介绍",
              prop: "content",
              hide:true,
              type:'ueditor',
              row:true,
              span:24,
              maxlength:2000,
              required: true,
              formslot:true,
              params: {
              options: {
                        //普通图片上传
                        action: '/api/blade-resource/oss/endpoint/put-file',
                        props: {
                                res: 'data',
                                url: 'link',
                        },
                        },
              },
              rules: [{
                            required: true,
                            message: "请填写服务介绍",
                            trigger: "change"
                      },
                     { max: 2000, message: '请控制在2000个字符内', trigger: 'change' }
                     ],
              component: 'AvueUeditor'
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.orderserviceitem_add, true),
          viewBtn: this.vaildData(this.permission.orderserviceitem_view, true),
          delBtn: this.vaildData(this.permission.orderserviceitem_delete, true),
          editBtn: this.vaildData(this.permission.orderserviceitem_edit, true)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created: {

    },
    methods: {
      // 富文本处理图片上传问题
       handleImageAdded:function(file, Editor, cursorLocation, resetUploader) {
         if(this.disabled){
           return;
         }
          var formData = new FormData();
          formData.append("file", file);
          // 通过上传接口返回url，将url放入富文本编辑器中
          putFile(formData).then(res=>{
            let url = res.data.link;
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          }).catch(err => {
            console.log(err);
          });


       },
      // 子类型切换
      subModuleIdChange(){
        this.$forceUpdate();
      },
      getAllSubModuleList(moduleType,projectId){
        getAllSubModuleList({moduleType:moduleType,projectId:projectId}).then((data)=>{
          this.subModuleList = data.data;
          // this.handlerHide(data.data)
        })
      },
      moduleTypeNamChange(value,type){
        console.log(type)
        if(type === 1){
          this.query.moduleTypeName = value;
          this.query.moduleType = value;
          this.getAllSubModuleList(value,this.query.projectId)
        } else if(type === 2){
          this.form.moduleTypeName = value;
          this.form.moduleType = value;
          this.form.subModuleId = '';
          // this.query.subModuleId = '';
          this.getAllSubModuleList(value,this.form.projectId)
        }
        this.$forceUpdate();
      },
      modulesSetting(projectId){
        modulesSetting(projectId).then((data)=>{
          console.log(data);
          this.moduleTypeList = data.data;
          this.query.moduleTypeName = '';
          this.query.moduleType = '';
          this.form.moduleTypeName = '';
          this.form.moduleType = '';
          this.form.subModuleId = '';
          this.query.subModuleId = '';
        });
      },
      openList(row){
        this.listFlag = true;
        this.$refs.itemList.openItemListOnload(row.id);
      },
      projectChange(value){
        this.query.projectId = value;
        this.query.project = value;
        this.modulesSetting(value);
        this.$forceUpdate();
      },
      // 新增表单项目切换
      projectAddChange(value){
        this.form.projectId = value;
        this.form.project = value;
        this.modulesSetting(value);
        this.$forceUpdate();
      },
      // 新增
      rowSave(row, loading, done) {
        console.log(row.subModuleId);
        if (this.subModuleList && JSON.stringify(this.subModuleList)==="{}") {

        }else if(!this.subModuleList){

        }else{
          let status = false;
          this.subModuleList.forEach((value, index, array)=>{
            if(value.status === 1){
              status = true;
            }
          });
          if (!row.subModuleId && status) {
            this.$message.error("请选择'工单子类型'!");
            done();
            return;
          }
        }
        let temAttachIds = '';
        row.attachIds.forEach(item => {
            temAttachIds += item.id + ',';
        });
        row.attachIds = temAttachIds;
        row.imgAttachId = row.imgAttachId[0].id;
         if(row.content == '<p><br></p>'){
           this.$message({
            showClose: true,
            message: '请输入服务介绍',
            type: 'warning'
          });
          done();
          return;
        }
        // 新增
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      // 编辑
      rowUpdate(row, index, loading, done) {
        setTimeout(()=>{
          let temAttachIds = '';
          row.attachIds.forEach(item => {
              temAttachIds += item.id + ',';
          });
          row.attachIds = temAttachIds;
          row.imgAttachId = row.imgAttachId[0].id;
          if(row.content == '<p><br></p>'){
            this.$message({
              showClose: true,
              message: '请输入服务介绍',
              type: 'warning'
            });
            done();
            return;
          }

          this.$refs.crud.validate(ele=>{
            console.log(ele)
          })
          update(row).then(() => {
            loading();
            this.onLoad();
            this.$message.success('操作成功!');
          }, error => {
            done();
            console.log(error);
          });
        },0)
        
      },
      // 删除
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      // 打开弹窗
      beforeOpen(done, type) {
        
        this.disabled = false;
        this.form.imgAttachId = [];
        this.form.attachIds = [];
        if (type === 'edit') {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            modulesSetting(data.projectId).then((res)=>{
              this.moduleTypeList = res.data;
            });
            this.getAllSubModuleList(data.moduleType,data.projectId);
            this.form.moduleTypeName = data.moduleType;
              getAttachByMainIdList({mainId:this.form.id}).then(({data}) => {
                      if (data){
                        let temArrimgAttachId = [];
                        let temArrattachIds = [];
                        this.form.imgAttachId = [];
                        this.form.attachIds = [];

                        data.forEach(item=>{
                          if(item.moduleType == 612){
                            temArrimgAttachId.push(item);
                          }else{
                            temArrattachIds.push(item)
                          }
                         
                        })
                        this.form.imgAttachId = temArrimgAttachId;
                        this.form.attachIds = temArrattachIds;
                        
                        console.log(this.form.attachIds)
                      }
              })
          })
        }
        if(type === 'view'){
          this.disabled = true;
         getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            modulesSetting(data.projectId).then((res)=>{
              this.moduleTypeList = res.data;
            });
            this.getAllSubModuleList(data.moduleType,data.projectId);
            this.form.moduleTypeName = data.moduleType;
              getAttachByMainIdList({mainId:this.form.id}).then(({data}) => {
                      if (data){
                        let temArrimgAttachId = [];
                        let temArrattachIds = [];
                        this.form.imgAttachId = [];
                        this.form.attachIds = [];

                        data.forEach(item=>{
                          if(item.moduleType == 612){
                            temArrimgAttachId.push(item);
                          }else{
                            temArrattachIds.push(item)
                          }
                         
                        })
                        this.form.imgAttachId = temArrimgAttachId;
                        this.form.attachIds = temArrattachIds;
                        
                        console.log(this.form.attachIds)
                      }
              })
          })
        }
        if(type === 'add'){
          setTimeout(()=>{
            this.form.projectId = this.projectList[0].id;
            this.form.project = this.projectList[0].name;
            this.form.attachIds = [];
            this.form.imgAttachId = [];
          })

        }
        done();
      },
      searchReset() {
        this.query.name = '';
        this.query.moduleTypeName = '';
        this.query.moduleType = '';
        this.query.subModuleId = '';
        this.onLoad();
      },
      searchChange(params,done) {
        // this.query = params;
        this.query.name = params.name;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log(this.query);
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              this.modulesSetting(this.projectList[0].id);
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style scoped>
    @import "~vue2-editor/dist/vue2-editor.css";

    /* Import the Quill styles you want */
    @import '~quill/dist/quill.core.css';
    @import '~quill/dist/quill.bubble.css';
    @import '~quill/dist/quill.snow.css';
</style>
